import init, {
  process_player_codes,
} from "../../public/deckgym-wasm/pkg/deckgym_wasm.js";

// This is a 3-number array of (win, loss, draw)
type WinsVec = Int32Array;

interface WorkerResponse {
  requestId: string;
  error?: string;
  winsvec?: WinsVec;
}

self.onmessage = async (event) => {
  const { requestId, deckAString, deckBString, players, totalSimulations } =
    event.data;
  try {
    await init({ module: "/deckgym-wasm/pkg/deckgym_wasm_bg.wasm" });

    // Now call the CPU-intensive function
    const winsvec = process_player_codes(
      deckAString,
      deckBString,
      players,
      totalSimulations
    );

    // Post result back to main thread
    const response: WorkerResponse = { requestId, winsvec };
    self.postMessage(response);
  } catch (error: unknown) {
    console.error("Worker error:", error, typeof error);
    if (error instanceof Error) {
      const response: WorkerResponse = { requestId, error: error.message };
      self.postMessage(response);
    } else {
      const response: WorkerResponse = { requestId, error: "Unknown Error" };
      self.postMessage(response);
    }
  }
};
